module.exports = __webpack_public_path__ + "media/images/soar/site/icons/commas-084ba4064d4f9eb1036000cee9ea89db.svg";